<template>
  <blank-container
    :title="$route.meta.title[$i18n.locale]"
    @addBtn="$router.push({ name: 'bloggers-create' })"
  >
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :pagination="false"
      :row-key="(rec) => rec.id"
      class="bloggers-table"
    >
      <template slot="position" slot-scope="item">
        <span class="text-center">{{ item.position }}</span>
      </template>
      <template slot="lang_title" slot-scope="item">
        <a-row align="middle" type="flex">
          <a-avatar
            :size="64"
            :src="item.image_path && filesUrl + item.image_path"
            class="mr-1x"
            icon="user"
            shape="square"
          />
          {{ item.full_name ? item.full_name[$i18n.locale] : "Не указано" }}
        </a-row>
      </template>

      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({ name: 'bloggers-detail', params: { id: item.id } })
          "
        />
        <a-popconfirm
          title="Вы действительно хотите удалить?"
          cancel-text="Нет"
          ok-text="Да"
          @confirm="removeItem(item)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>
    <a-row class="mt-1">
      <!-- v-model="queryParams.page" -->
      <a-pagination
        show-size-changer
        :page-size="+params.items_count"
        :total="+count"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
    </a-row>
  </blank-container>
</template>

<script>
const columns = [
  {
    title: "Поз.",
    key: "position",
    scopedSlots: { customRender: "position" },
    className: "text-center font-md"
  },
  {
    title: "Ф.И.О",
    key: "full_name",
    scopedSlots: { customRender: "lang_title" }
  },
  {
    title: "Действие",
    key: "operation",
    fixed: "right",
    scopedSlots: { customRender: "operation" }
  }
]

export default {
  data: () => ({
    loading: false,
    columns,
    list: [],
    count: 0,
    params: {
      order_by: "position",
      pages_count: 1,
      items_count: 10
    }
  }),
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    "$i18n.locale": {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    onChange(p) {
      this.params.page_count = +p
      this.fetchData()
    },
    onShowSizeChange(current, pageSize) {
      this.params.items_count = +pageSize
      this.params.page_count = +current
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      try {
        const { data } = await this.$store.dispatch(
          "bloggers/fetch",
          this.params
        )
        if (data) {
          this.list = data.results || []
          this.count = data.items_count
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }

      this.loading = false
    },

    async removeItem(item) {
      //todo
      try {
        await this.$store.dispatch("bloggers/removeItemAction", item.id)

        // console.log("removeItem", res);
        this.fetchData()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
